@if (vazia()) {
  <p class="dz-muted">Sem vínculos suficientes para montar a matriz.</p>
} @else {
  <div class="mx-toolbar">
    <span class="dz-label">Linhas</span>
    <div class="dz-seg" role="group" aria-label="Linhas">
      <button
        type="button"
        class="dz-seg__btn"
        [class.dz-seg__btn--on]="empresasNasLinhas()"
        [attr.aria-pressed]="empresasNasLinhas()"
        (click)="empresasNasLinhas.set(true)">
        Empresas
      </button>
      <button
        type="button"
        class="dz-seg__btn"
        [class.dz-seg__btn--on]="!empresasNasLinhas()"
        [attr.aria-pressed]="!empresasNasLinhas()"
        (click)="empresasNasLinhas.set(false)">
        Sócios
      </button>
    </div>
  </div>

  @if (ocultos(); as texto) {
    <p class="dz-note dz-note--warn mx-ocultos">{{ texto }}</p>
  }

  <div class="mx-scroll">
    <table class="mx">
      <thead>
        <tr>
          <th class="mx__corner dz-label">
            {{ empresasNasLinhas() ? 'empresa \\ sócio' : 'sócio \\ empresa' }}
          </th>
          @for (col of colunas(); track col.id) {
            <th class="mx__col">
              <div class="mx__vertical">
                @if (col.socio; as s) {
                  <ng-container
                    *ngTemplateOutlet="rotuloSocio; context: { $implicit: s, abrev: true }" />
                } @else if (col.empresa; as e) {
                  <ng-container
                    *ngTemplateOutlet="rotuloEmpresa; context: { $implicit: e, abrev: true }" />
                }
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (linha of linhas(); track linha.id) {
          <tr>
            <td class="mx__row" [class.mx__row--focus]="linhaEmFoco(linha.id)">
              @if (linha.empresa; as e) {
                <ng-container
                  *ngTemplateOutlet="rotuloEmpresa; context: { $implicit: e, abrev: false }" />
              } @else if (linha.socio; as s) {
                <ng-container
                  *ngTemplateOutlet="rotuloSocio; context: { $implicit: s, abrev: false }" />
              }
            </td>
            @for (c of linha.celulas; track c.chave) {
              <td
                class="mx__cell"
                [class.mx__cell--focus]="emFoco(c)"
                [attr.title]="c.titulo"
                (mouseenter)="foco.set({ socio: c.socioId, empresa: c.cnpj })"
                (mouseleave)="foco.set({ socio: null, empresa: null })">
                @if (c.ligado) {
                  <span class="mx__mark" [style.background]="c.cor"></span>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="mx-legend">
    <span
      ><span
        class="sq"
        [style.background]="display.highlightRoot() ? cores.raiz : cores.empresa"></span>
      raiz da consulta</span
    >
    <span
      ><span class="sq" [style.background]="cores.empresa"></span> participa (empresa ativa)</span
    >
    <span
      ><span class="sq" [style.background]="cores.alerta"></span> participa (situação com
      alerta)</span
    >
    <span class="mx-legend__hint">
      O número ao lado do sócio é quantas empresas da rede ele liga — colunas com várias marcas são
      os elos do grupo.
    </span>
  </div>
}

<ng-template #rotuloEmpresa let-e let-abrev="abrev">
  <span class="lbl" [attr.title]="tituloEmpresa(e)">
    <span class="dot" [style.background]="corEmpresa(e)"></span>
    <span class="lbl__txt" [class.lbl__txt--alert]="e.alerta" [class.lbl__txt--root]="e.raiz">{{
      abrev ? encurtar(e.nome) : e.nome
    }}</span>
  </span>
</ng-template>

<ng-template #rotuloSocio let-s let-abrev="abrev">
  <span class="lbl" [attr.title]="tituloSocio(s)">
    @if (s.grau > 1) {
      <span class="grau">{{ s.grau }}</span>
    } @else {
      <span class="dot" [style.background]="s.tipo === 'PJ' ? cores.empresa : cores.pessoa"></span>
    }
    <span class="lbl__txt lbl__txt--socio">{{ abrev ? encurtar(s.nome) : s.nome }}</span>
  </span>
</ng-template>
